export default __webpack_public_path__ + "static/image-33-d09c312ba8db0af91a8e20559f76d0a9.jpg";